export default __webpack_public_path__ + "static/logo-sz-4bb135e88ce6166bfc00ba06eebbabe7.png";